import type * as SchemaTypes from '../../../../apolloClient.types';

import type { PersonalCopingLikertScaleResultFragment, PersonalCopingRatingScaleResultFragment } from '../../../../pages/AssessmentLauncher/PersonalCoping/PersonalCoping.api';
import type { AitAssessmentResultDataFragment } from '../../../../pages/AssessmentLauncher/AiT/AiT.api';
import { gql } from '@apollo/client';
import { PersonalCopingRatingScaleResultFragmentDoc, PersonalCopingLikertScaleResultFragmentDoc } from '../../../../pages/AssessmentLauncher/PersonalCoping/PersonalCoping.api';
import { AitAssessmentResultDataFragmentDoc } from '../../../../pages/AssessmentLauncher/AiT/AiT.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchResultRankQueryVariables = SchemaTypes.Exact<{
  resultId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchResultRankQuery = (
  { __typename: 'Query' }
  & { assessmentResultRank?: SchemaTypes.Maybe<Array<(
    { __typename: 'AssessmentResultMetricRank' }
    & Pick<SchemaTypes.AssessmentResultMetricRank, 'key' | 'label' | 'direction' | 'rank' | 'totalParticipants'>
  )>> }
);

export type FetchResultQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchResultQuery = (
  { __typename: 'Query' }
  & { assessmentResult: (
    { __typename: 'AssessmentResult' }
    & ResultDataFragment
  ) }
);

export type ResultDataFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'userId' | 'moduleInstanceId' | 'completedAt'>
  & { user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, result: (
    { __typename: 'AitResult' }
    & ResultAitResultFragment
  ) | { __typename: 'CardioRespResult' } | (
    { __typename: 'DigitSpanResult' }
    & ResultDigitSpanResultFragment
  ) | (
    { __typename: 'GrowthMindsetResult' }
    & ResultGrowthMindsetResultFragment
  ) | { __typename: 'InbodyCompositionResult' } | (
    { __typename: 'IndividualMotivationResult' }
    & ResultIndividualMotivationResultFragment
  ) | (
    { __typename: 'ML360Result' }
    & ResultMl360ResultFragment
  ) | (
    { __typename: 'NBackResult' }
    & ResultNBackResultFragment
  ) | (
    { __typename: 'OrganisationalAiReadinessResult' }
    & ResultOrganisationalAiReadinessResultFragment
  ) | (
    { __typename: 'PersonalCopingResult' }
    & ResultPersonalCopingResultFragment
  ) | { __typename: 'ProcessingSpeedResult' } | (
    { __typename: 'SartResult' }
    & ResultSartResultFragment
  ) | (
    { __typename: 'SelfDeterminationResult' }
    & ResultSelfDeterminationResultFragment
  ) | (
    { __typename: 'SpatialPlanningResult' }
    & ResultSpatialPlanningResultFragment
  ) | { __typename: 'StrengthResult' } | (
    { __typename: 'TeamResilienceResult' }
    & ResultTeamResilienceResultFragment
  ) | { __typename: 'TrainersNotesResult' } | (
    { __typename: 'VisualReactionResult' }
    & ResultVisualReactionResultFragment
  ), assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
    & { program?: SchemaTypes.Maybe<(
      { __typename: 'Program' }
      & Pick<SchemaTypes.Program, 'name'>
    )>, moduleSnapshots: Array<(
      { __typename: 'ModuleSnapshot' }
      & Pick<SchemaTypes.ModuleSnapshot, 'moduleInstanceId'>
      & { configuration: { __typename: 'AitModuleInstanceConfiguration' } | { __typename: 'BmpConfiguration' } | { __typename: 'CardioRespConfiguration' } | { __typename: 'DigitSpanModuleInstanceConfiguration' } | { __typename: 'FinSwimConfiguration' } | (
        { __typename: 'GrowthMindsetModuleInstanceConfiguration' }
        & { scoreLevels: Array<(
          { __typename: 'GrowthMindsetScoreLevel' }
          & Pick<SchemaTypes.GrowthMindsetScoreLevel, 'name' | 'minScore'>
          & { categoryDescriptions: Array<(
            { __typename: 'GrowthMindsetCategoryDescription' }
            & Pick<SchemaTypes.GrowthMindsetCategoryDescription, 'category' | 'description'>
          )> }
        )> }
      ) | { __typename: 'InbodyCompositionConfiguration' } | { __typename: 'IndividualMotivationModuleInstanceConfiguration' } | { __typename: 'IpptConfiguration' } | { __typename: 'ML360ModuleInstanceConfiguration' } | { __typename: 'March20KmConfiguration' } | { __typename: 'NBackModuleInstanceConfiguration' } | { __typename: 'NutritionAudioConfiguration' } | { __typename: 'NutritionPdfConfiguration' } | { __typename: 'NutritionVideoConfiguration' } | { __typename: 'OrganisationalAiReadinessModuleInstanceConfiguration' } | { __typename: 'PersonalCopingModuleInstanceConfiguration' } | { __typename: 'ProcessingSpeedModuleInstanceConfiguration' } | { __typename: 'SARTModuleInstanceConfiguration' } | { __typename: 'SelfDeterminationModuleInstanceConfiguration' } | { __typename: 'SocConfiguration' } | { __typename: 'SpatialPlanningModuleInstanceConfiguration' } | { __typename: 'StrengthConfiguration' } | { __typename: 'TeamResilienceModuleInstanceConfiguration' } | { __typename: 'TrainingAudioConfiguration' } | { __typename: 'TrainingDigitSpanConfiguration' } | { __typename: 'TrainingNBackConfiguration' } | { __typename: 'TrainingPdfConfiguration' } | { __typename: 'TrainingProcessingSpeedConfiguration' } | { __typename: 'TrainingVideoConfiguration' } | { __typename: 'VisualReactionModuleInstanceConfiguration' } | { __typename: 'WeightConfiguration' } }
    )> }
  )> }
);

export type ResultSelfDeterminationResultFragment = (
  { __typename: 'SelfDeterminationResult' }
  & { surveys: Array<(
    { __typename: 'SelfDeterminationSurveyResult' }
    & Pick<SchemaTypes.SelfDeterminationSurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & Pick<SchemaTypes.LikertScaleResult, 'score' | 'total' | 'label'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'SelfDeterminationCategoryAverage' }
    & Pick<SchemaTypes.SelfDeterminationCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore'>
  )> }
);

export type ResultMl360ResultFragment = (
  { __typename: 'ML360Result' }
  & { surveys: Array<(
    { __typename: 'ML360SurveyResult' }
    & Pick<SchemaTypes.Ml360SurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'Scoring' }
      & Pick<SchemaTypes.Scoring, 'label' | 'score'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'ML360CategoryResult' }
    & Pick<SchemaTypes.Ml360CategoryResult, 'category' | 'averageScore' | 'maxScore'>
  )> }
);

export type ResultSartResultFragment = (
  { __typename: 'SartResult' }
  & Pick<SchemaTypes.SartResult, 'correctHits' | 'misses' | 'incorrectPresses' | 'averageResponseTimeMs' | 'fastestResponseTimeMs'>
  & { trials: Array<(
    { __typename: 'SartTrialResult' }
    & Pick<SchemaTypes.SartTrialResult, 'index' | 'stimulusDigit' | 'responseTimeMs' | 'isTriggerDigit' | 'isCorrect' | 'errorType'>
  )> }
);

export type ResultSpatialPlanningResultFragment = (
  { __typename: 'SpatialPlanningResult' }
  & Pick<SchemaTypes.SpatialPlanningResult, 'correctAnswers' | 'incorrectAnswers' | 'accuracy' | 'averageResponseTimeMs' | 'fastestResponseTimeMs'>
  & { trials: Array<(
    { __typename: 'SpatialPlanningTrialResult' }
    & Pick<SchemaTypes.SpatialPlanningTrialResult, 'index' | 'correctMoves' | 'respondedMoves' | 'numberOfAttempts' | 'responseTimeMs' | 'isCorrect'>
  )> }
);

export type ResultVisualReactionResultFragment = (
  { __typename: 'VisualReactionResult' }
  & Pick<SchemaTypes.VisualReactionResult, 'correctAnswers' | 'incorrectAnswers' | 'fastestResponseTimeMs' | 'averageResponseTimeMs' | 'accuracy'>
  & { rounds: Array<(
    { __typename: 'VisualReactionRoundResult' }
    & Pick<SchemaTypes.VisualReactionRoundResult, 'accuracyPerRound' | 'averageResponseTimeMsPerRound'>
    & { questions: Array<(
      { __typename: 'VisualReactionQuestionResult' }
      & Pick<SchemaTypes.VisualReactionQuestionResult, 'isCorrect' | 'responseTimeMs' | 'errorType'>
    )> }
  )> }
);

export type ResultTeamResilienceResultFragment = (
  { __typename: 'TeamResilienceResult' }
  & { surveys: Array<(
    { __typename: 'TeamResilienceSurveyResult' }
    & Pick<SchemaTypes.TeamResilienceSurveyResult, 'category' | 'subcategory' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & ResultLikertScaleFragment
    ) | (
      { __typename: 'RatingScaleResult' }
      & ResultRatingScaleFragment
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'TeamResilienceCategoryAverage' }
    & Pick<SchemaTypes.TeamResilienceCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore'>
  )>, subcategoryAverages: Array<(
    { __typename: 'TeamResilienceSubcategoryAverage' }
    & Pick<SchemaTypes.TeamResilienceSubcategoryAverage, 'category' | 'subcategory' | 'maximumPossibleScore' | 'averageScore'>
  )> }
);

export type ResultIndividualMotivationResultFragment = (
  { __typename: 'IndividualMotivationResult' }
  & { surveys: Array<(
    { __typename: 'IndividualMotivationSurveyResult' }
    & Pick<SchemaTypes.IndividualMotivationSurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & ResultLikertScaleFragment
    ) | (
      { __typename: 'RatingScaleResult' }
      & ResultRatingScaleFragment
    ) }
  )>, categoryBreakdowns: Array<(
    { __typename: 'IndividualMotivationCategoryBreakdown' }
    & Pick<SchemaTypes.IndividualMotivationCategoryBreakdown, 'category' | 'maximumPossibleScore' | 'averageScore'>
    & { subcategoryAverages: Array<(
      { __typename: 'IndividualMotivationSubcategoryAverage' }
      & Pick<SchemaTypes.IndividualMotivationSubcategoryAverage, 'subcategory' | 'maximumPossibleScore' | 'averageScore'>
    )> }
  )> }
);

export type ResultLikertScaleFragment = (
  { __typename: 'LikertScaleResult' }
  & Pick<SchemaTypes.LikertScaleResult, 'type' | 'score' | 'total' | 'label'>
);

export type ResultRatingScaleFragment = (
  { __typename: 'RatingScaleResult' }
  & Pick<SchemaTypes.RatingScaleResult, 'type' | 'score' | 'minimumValue' | 'maximumValue'>
);

export type ResultPersonalCopingResultFragment = (
  { __typename: 'PersonalCopingResult' }
  & { surveys: Array<(
    { __typename: 'PersonalCopingSurveyResult' }
    & Pick<SchemaTypes.PersonalCopingSurveyResult, 'category' | 'question'>
    & { dimensionScores: Array<(
      { __typename: 'PersonalCopingDimensionScore' }
      & Pick<SchemaTypes.PersonalCopingDimensionScore, 'dimension' | 'dimensionInstruction'>
      & { scoring?: SchemaTypes.Maybe<(
        { __typename: 'LikertScaleResult' }
        & PersonalCopingLikertScaleResultFragment
      ) | (
        { __typename: 'RatingScaleResult' }
        & PersonalCopingRatingScaleResultFragment
      )> }
    )> }
  )>, dimensionAverages: Array<(
    { __typename: 'PersonalCopingDimensionAverage' }
    & Pick<SchemaTypes.PersonalCopingDimensionAverage, 'dimension' | 'maximumPossibleScore' | 'averageScore'>
  )>, categoryAverages: Array<(
    { __typename: 'PersonalCopingCategoryAverage' }
    & Pick<SchemaTypes.PersonalCopingCategoryAverage, 'category'>
    & { dimensionAverages: Array<(
      { __typename: 'PersonalCopingDimensionAverage' }
      & Pick<SchemaTypes.PersonalCopingDimensionAverage, 'dimension' | 'maximumPossibleScore' | 'averageScore'>
    )> }
  )>, resultAreas: Array<(
    { __typename: 'PersonalCopingResultAreaConfiguration' }
    & Pick<SchemaTypes.PersonalCopingResultAreaConfiguration, 'label' | 'xAxisFrom' | 'xAxisTo' | 'yAxisFrom' | 'yAxisTo' | 'color'>
  )> }
);

export type ResultNBackResultFragment = (
  { __typename: 'NBackResult' }
  & Pick<SchemaTypes.NBackResult, 'numberOfBlocks' | 'accuracy' | 'dPrime' | 'meanHitRtMs' | 'status'>
  & { trials: Array<(
    { __typename: 'NBackTrialResult' }
    & Pick<SchemaTypes.NBackTrialResult, 'block' | 'trialNumber' | 'nLevel' | 'responseTimeMs' | 'isCorrect'>
    & { nBackErrorType: SchemaTypes.NBackTrialResult['errorType'] }
  )>, blockSummaries: Array<(
    { __typename: 'NBackBlockSummary' }
    & Pick<SchemaTypes.NBackBlockSummary, 'block' | 'accuracy' | 'dPrime' | 'meanHitRtMs'>
  )> }
);

export type ResultGrowthMindsetResultFragment = (
  { __typename: 'GrowthMindsetResult' }
  & { surveys: Array<(
    { __typename: 'GrowthMindsetSurveyResult' }
    & Pick<SchemaTypes.GrowthMindsetSurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & Pick<SchemaTypes.LikertScaleResult, 'score' | 'total' | 'label'>
    ) | (
      { __typename: 'RatingScaleResult' }
      & Pick<SchemaTypes.RatingScaleResult, 'score' | 'minimumValue' | 'maximumValue'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'GrowthMindsetCategoryAverage' }
    & Pick<SchemaTypes.GrowthMindsetCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore' | 'label' | 'description'>
  )> }
);

export type ResultOrganisationalAiReadinessResultFragment = (
  { __typename: 'OrganisationalAiReadinessResult' }
  & { categoryAverages: Array<(
    { __typename: 'OrganisationalAiReadinessCategoryAverage' }
    & Pick<SchemaTypes.OrganisationalAiReadinessCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore' | 'label' | 'description'>
  )>, overallScore: (
    { __typename: 'OrganisationalAiReadinessOverallScore' }
    & Pick<SchemaTypes.OrganisationalAiReadinessOverallScore, 'score' | 'maximumPossibleScore' | 'label'>
  ) }
);

export type ResultDigitSpanResultFragment = (
  { __typename: 'DigitSpanResult' }
  & { variantSummaries: Array<(
    { __typename: 'DigitSpanVariantSummary' }
    & Pick<SchemaTypes.DigitSpanVariantSummary, 'variant' | 'spanScore' | 'totalCorrectTrials' | 'trialsAttempted' | 'completionStatus'>
  )>, trials: Array<(
    { __typename: 'DigitSpanTrialResult' }
    & Pick<SchemaTypes.DigitSpanTrialResult, 'variant' | 'spanLevel' | 'trialNumber' | 'sequencePresented' | 'responseSequence' | 'correct' | 'responseTimeMs'>
    & { digitSpanErrorType: SchemaTypes.DigitSpanTrialResult['errorType'] }
  )> }
);

export type ResultAitResultFragment = (
  { __typename: 'AitResult' }
  & AitAssessmentResultDataFragment
);

export const ResultDigitSpanResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultDigitSpanResult on DigitSpanResult {
  variantSummaries {
    variant
    spanScore
    totalCorrectTrials
    trialsAttempted
    completionStatus
  }
  trials {
    variant
    spanLevel
    trialNumber
    sequencePresented
    responseSequence
    correct
    responseTimeMs
    digitSpanErrorType: errorType
  }
}
    `;
export const ResultSartResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultSartResult on SartResult {
  trials {
    index
    stimulusDigit
    responseTimeMs
    isTriggerDigit
    isCorrect
    errorType
  }
  correctHits
  misses
  incorrectPresses
  averageResponseTimeMs
  fastestResponseTimeMs
}
    `;
export const ResultSpatialPlanningResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultSpatialPlanningResult on SpatialPlanningResult {
  trials {
    index
    correctMoves
    respondedMoves
    numberOfAttempts
    responseTimeMs
    isCorrect
  }
  correctAnswers
  incorrectAnswers
  accuracy
  averageResponseTimeMs
  fastestResponseTimeMs
}
    `;
export const ResultVisualReactionResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultVisualReactionResult on VisualReactionResult {
  rounds {
    questions {
      isCorrect
      responseTimeMs
      errorType
    }
    accuracyPerRound
    averageResponseTimeMsPerRound
  }
  correctAnswers
  incorrectAnswers
  fastestResponseTimeMs
  averageResponseTimeMs
  accuracy
}
    `;
export const ResultMl360ResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultML360Result on ML360Result {
  surveys {
    ... on ML360SurveyResult {
      category
      question
      scoring {
        ... on Scoring {
          label
          score
        }
      }
    }
  }
  categoryAverages {
    category
    averageScore
    maxScore
  }
}
    `;
export const ResultSelfDeterminationResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultSelfDeterminationResult on SelfDeterminationResult {
  surveys {
    category
    question
    scoring {
      score
      total
      label
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
  }
}
    `;
export const ResultLikertScaleFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultLikertScale on LikertScaleResult {
  type
  score
  total
  label
}
    `;
export const ResultRatingScaleFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultRatingScale on RatingScaleResult {
  type
  score
  minimumValue
  maximumValue
}
    `;
export const ResultTeamResilienceResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultTeamResilienceResult on TeamResilienceResult {
  surveys {
    category
    subcategory
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        ...ResultLikertScale
      }
      ... on RatingScaleResult {
        ...ResultRatingScale
      }
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
  }
  subcategoryAverages {
    category
    subcategory
    maximumPossibleScore
    averageScore
  }
}
    ${ResultLikertScaleFragmentDoc}
${ResultRatingScaleFragmentDoc}`;
export const ResultIndividualMotivationResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultIndividualMotivationResult on IndividualMotivationResult {
  surveys {
    category
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        ...ResultLikertScale
      }
      ... on RatingScaleResult {
        ...ResultRatingScale
      }
    }
  }
  categoryBreakdowns {
    category
    maximumPossibleScore
    averageScore
    subcategoryAverages {
      subcategory
      maximumPossibleScore
      averageScore
    }
  }
}
    ${ResultLikertScaleFragmentDoc}
${ResultRatingScaleFragmentDoc}`;
export const ResultPersonalCopingResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultPersonalCopingResult on PersonalCopingResult {
  surveys {
    category
    question
    dimensionScores {
      dimension
      dimensionInstruction
      scoring {
        __typename
        ... on LikertScaleResult {
          ...PersonalCopingLikertScaleResult
        }
        ... on RatingScaleResult {
          ...PersonalCopingRatingScaleResult
        }
      }
    }
  }
  dimensionAverages {
    dimension
    maximumPossibleScore
    averageScore
  }
  categoryAverages {
    category
    dimensionAverages {
      dimension
      maximumPossibleScore
      averageScore
    }
  }
  resultAreas {
    label
    xAxisFrom
    xAxisTo
    yAxisFrom
    yAxisTo
    color
  }
}
    ${PersonalCopingLikertScaleResultFragmentDoc}
${PersonalCopingRatingScaleResultFragmentDoc}`;
export const ResultNBackResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultNBackResult on NBackResult {
  numberOfBlocks
  accuracy
  dPrime
  meanHitRtMs
  status
  trials {
    block
    trialNumber
    nLevel
    responseTimeMs
    isCorrect
    nBackErrorType: errorType
  }
  blockSummaries {
    block
    accuracy
    dPrime
    meanHitRtMs
  }
}
    `;
export const ResultGrowthMindsetResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultGrowthMindsetResult on GrowthMindsetResult {
  surveys {
    category
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        score
        total
        label
      }
      ... on RatingScaleResult {
        score
        minimumValue
        maximumValue
      }
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
    label
    description
  }
}
    `;
export const ResultOrganisationalAiReadinessResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultOrganisationalAiReadinessResult on OrganisationalAiReadinessResult {
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
    label
    description
  }
  overallScore {
    score
    maximumPossibleScore
    label
  }
}
    `;
export const ResultAitResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultAitResult on AitResult {
  ...AitAssessmentResultData
}
    ${AitAssessmentResultDataFragmentDoc}`;
export const ResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultData on AssessmentResult {
  id
  userId
  user {
    ... on BaseUser {
      id
      name
    }
  }
  moduleInstance {
    name
  }
  moduleInstanceId
  completedAt
  result {
    ... on DigitSpanResult {
      ...ResultDigitSpanResult
    }
    ... on SartResult {
      ...ResultSartResult
    }
    ... on SpatialPlanningResult {
      ...ResultSpatialPlanningResult
    }
    ... on VisualReactionResult {
      ...ResultVisualReactionResult
    }
    ... on ML360Result {
      ...ResultML360Result
    }
    ... on SelfDeterminationResult {
      ...ResultSelfDeterminationResult
    }
    ... on TeamResilienceResult {
      ...ResultTeamResilienceResult
    }
    ... on IndividualMotivationResult {
      ...ResultIndividualMotivationResult
    }
    ... on PersonalCopingResult {
      ...ResultPersonalCopingResult
    }
    ... on NBackResult {
      ...ResultNBackResult
    }
    ... on GrowthMindsetResult {
      ...ResultGrowthMindsetResult
    }
    ... on OrganisationalAiReadinessResult {
      ...ResultOrganisationalAiReadinessResult
    }
    ... on AitResult {
      ...ResultAitResult
    }
  }
  assessmentRun {
    name
    program {
      name
    }
    moduleSnapshots {
      moduleInstanceId
      configuration {
        ... on GrowthMindsetModuleInstanceConfiguration {
          scoreLevels {
            name
            minScore
            categoryDescriptions {
              category
              description
            }
          }
        }
      }
    }
  }
}
    ${ResultDigitSpanResultFragmentDoc}
${ResultSartResultFragmentDoc}
${ResultSpatialPlanningResultFragmentDoc}
${ResultVisualReactionResultFragmentDoc}
${ResultMl360ResultFragmentDoc}
${ResultSelfDeterminationResultFragmentDoc}
${ResultTeamResilienceResultFragmentDoc}
${ResultIndividualMotivationResultFragmentDoc}
${ResultPersonalCopingResultFragmentDoc}
${ResultNBackResultFragmentDoc}
${ResultGrowthMindsetResultFragmentDoc}
${ResultOrganisationalAiReadinessResultFragmentDoc}
${ResultAitResultFragmentDoc}`;
export const FetchResultRankDocument = /*#__PURE__*/ gql`
    query FetchResultRank($resultId: ObjectID!) {
  assessmentResultRank(resultId: $resultId) {
    key
    label
    direction
    rank
    totalParticipants
  }
}
    `;

/**
 * __useFetchResultRankQuery__
 *
 * To run a query within a React component, call `useFetchResultRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResultRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResultRankQuery({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useFetchResultRankQuery(baseOptions: Apollo.QueryHookOptions<FetchResultRankQuery, FetchResultRankQueryVariables> & ({ variables: FetchResultRankQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResultRankQuery, FetchResultRankQueryVariables>(FetchResultRankDocument, options);
      }
export function useFetchResultRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResultRankQuery, FetchResultRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResultRankQuery, FetchResultRankQueryVariables>(FetchResultRankDocument, options);
        }
// @ts-ignore
export function useFetchResultRankSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchResultRankQuery, FetchResultRankQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultRankQuery, FetchResultRankQueryVariables>;
export function useFetchResultRankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultRankQuery, FetchResultRankQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultRankQuery | undefined, FetchResultRankQueryVariables>;
export function useFetchResultRankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultRankQuery, FetchResultRankQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchResultRankQuery, FetchResultRankQueryVariables>(FetchResultRankDocument, options);
        }
export type FetchResultRankQueryHookResult = ReturnType<typeof useFetchResultRankQuery>;
export type FetchResultRankLazyQueryHookResult = ReturnType<typeof useFetchResultRankLazyQuery>;
export type FetchResultRankSuspenseQueryHookResult = ReturnType<typeof useFetchResultRankSuspenseQuery>;
export type FetchResultRankQueryResult = Apollo.QueryResult<FetchResultRankQuery, FetchResultRankQueryVariables>;
export const FetchResultDocument = /*#__PURE__*/ gql`
    query FetchResult($id: ObjectID!) {
  assessmentResult(id: $id) {
    ...ResultData
  }
}
    ${ResultDataFragmentDoc}`;

/**
 * __useFetchResultQuery__
 *
 * To run a query within a React component, call `useFetchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchResultQuery(baseOptions: Apollo.QueryHookOptions<FetchResultQuery, FetchResultQueryVariables> & ({ variables: FetchResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResultQuery, FetchResultQueryVariables>(FetchResultDocument, options);
      }
export function useFetchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResultQuery, FetchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResultQuery, FetchResultQueryVariables>(FetchResultDocument, options);
        }
// @ts-ignore
export function useFetchResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchResultQuery, FetchResultQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultQuery, FetchResultQueryVariables>;
export function useFetchResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultQuery, FetchResultQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultQuery | undefined, FetchResultQueryVariables>;
export function useFetchResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultQuery, FetchResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchResultQuery, FetchResultQueryVariables>(FetchResultDocument, options);
        }
export type FetchResultQueryHookResult = ReturnType<typeof useFetchResultQuery>;
export type FetchResultLazyQueryHookResult = ReturnType<typeof useFetchResultLazyQuery>;
export type FetchResultSuspenseQueryHookResult = ReturnType<typeof useFetchResultSuspenseQuery>;
export type FetchResultQueryResult = Apollo.QueryResult<FetchResultQuery, FetchResultQueryVariables>;